"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M11.641 10.509L13.766 12.634C14.079 12.947 14.079 13.453 13.766 13.765C13.61 13.922 13.405 14 13.201 14C12.995 14 12.791 13.922 12.635 13.765L10.535 11.665C10.24 11.37 9.761 11.37 9.466 11.665L7.366 13.765C7.209 13.922 7.005 14 6.8 14C6.596 14 6.391 13.922 6.235 13.765C5.922 13.453 5.922 12.947 6.235 12.634L8.31 10.559C8.619 10.25 8.619 9.749 8.31 9.44L6.235 7.365C5.922 7.053 5.922 6.547 6.235 6.234C6.547 5.922 7.053 5.922 7.366 6.234L9.441 8.309C9.75 8.618 10.25 8.618 10.56 8.309L12.635 6.234C12.948 5.922 13.453 5.922 13.766 6.234C14.079 6.547 14.079 7.053 13.766 7.365L11.641 9.49C11.36 9.772 11.36 10.228 11.641 10.509ZM10 2C5.582 2 2 5.582 2 10C2 14.418 5.582 18 10 18C14.418 18 18 14.418 18 10C18 5.582 14.418 2 10 2Z",
    fill: "#727B7F"
  }));
};